import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import useScrollToTop from '@/hooks/use-scroll-to-top';
import MovingBanner from '@/components/ui/MovingBanner';

const Layout = () => {
  // Use the scroll to top hook
  useScrollToTop();
  
  return (
    <div className="flex flex-col min-h-screen w-full max-w-full">
      <MovingBanner />
      <Navbar />
      <main className="flex-grow w-full">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
